import { render, staticRenderFns } from "./menu-element.component.vue?vue&type=template&id=2972db1e&scoped=true&lang=pug"
import script from "./menu-element.component.vue?vue&type=script&lang=ts"
export * from "./menu-element.component.vue?vue&type=script&lang=ts"
import style0 from "./menu-element.component.vue?vue&type=style&index=0&id=2972db1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2972db1e",
  null
  
)

export default component.exports